export const interceptionObj = {
  BeforePackage: "BeforePackage",
  BeforePackageOutboun: "BeforePackageOutboun",
  BeforeOverseaWarehouse: "BeforeOverseaWarehouse",
  BeforeManifest: "BeforeManifest",
  BeforeOverseaOutbound: "BeforeOverseaOutbound",
};

export const interceptionList = [
  {
    label: "BeforePackage",
    value: "BeforePackage",
  },
  {
    label: "BeforePackageOutboun",
    value: "BeforePackageOutboun",
  },
  {
    label: "BeforeOverseaWarehouse",
    value: "BeforeOverseaWarehouse",
  },
  {
    label: "BeforeManifest",
    value: "BeforeManifest",
  },
  {
    label: "BeforeOverseaOutbound",
    value: "BeforeOverseaOutbound",
  },
];

export const trackerObj = {
  pod: {
    value: "POD",
    label: "apod",
  },
  abnormal: {
    value: "EXCEPTION",
    label: "abnormal",
  },
  unapod: {
    value: "UNRECEIVING",
    label: "unapod",
  },
};

export const trackerObj1 = {
  pod: {
    value: "POD",
    label: "Delivered",
  },
  abnormal: {
    value: "EXCEPTION",
    label: "Abnormal",
  },
  unapod: {
    value: "UNRECEIVING",
    label: "Not delivered",
  },
};

export const orderTypeList = [
  {
    value: 0,
    label: "packet",
  },
  {
    value: 1,
    label: "Shuangqing",
  },
  {
    value: 2,
    label: "Helian",
  },
  {
    value: 3,
    label: "AmazonEasyship",
  },
  {
    value: 4,
    label: "NOON",
  },
  {
    value: 5,
    label: "TransferOrder",
  },
  {
    value: 6,
    label: "AliExpress",
  },
  {
    value: 7,
    label: "AmazonSelfship",
  },
];

export const typeList = [
  {
    value: "confirmed",
    label: "alreadConfirm",
  },
  {
    value: "unconfirmed",
    label: "unConfirm",
  },
];

export const codList = [
  {
    value: "NCND",
    label: "COD",
  },
  {
    value: "NOR",
    label: "PP",
  },
];

export const OverseasdList = [
  { value: 1, label: "YES" },
  { value: 2, label: "NO" },
];

export const searchTypeObj = [
  {
    value: "airway_number",
    label: "order_number",
  },
  {
    value: "client_refer_code",
    label: "order_userRef",
  },
  {
    value: "agent_refer_code",
    label: "order_refCode",
  },
];

export const planList = [
  {
    value: "selfMention",
    label: "self_mention",
  },
  {
    value: "sendExpress",
    label: "send_express",
  },
];
export const planStatus = {
  selfMention: "self_mention",
  sendExpress: "send_express",
};

export const paymentList = {
  0: " ",
  1: "cashPay",
  2: "coll",
};

export const unpackList = [
  {
    value: "YES",
    label: "YES",
  },
  {
    value: "NO",
    label: "NO",
  },
];
